import PublicWrapper from 'components/PublicPages/PublicWrapper';
import React from 'react';
import { useParams } from 'react-router-dom';
import useLocale from 'src/hooks/useLocale';
import LoadingCard from './LoadingCard';
import LocationConfirmation from './LocationConfirmation';
import StatusKeypadCard from './StatusKeypadCard';
import SuccessStatus from './SuccessStatus';
import { useVirtualTabletFlow } from './useVirtualTabletFlow';

const VirtualTablet: React.FC = () => {
  document.title = 'Solink Alarm';

  const locale = useLocale();
  const params = useParams();
  const siteId = params.siteId || '';

  const {
    step,
    storeNumber,
    digits,
    errorMessage,
    completedAction,
    locationFailureReason,
    armingSecondsRemaining,
    armingTotalSeconds,
    setStoreNumber,
    submitStoreNumber,
    retryLocation,
    enterDigit,
    clearDigits,
    submitArm,
    submitDisarm,
  } = useVirtualTabletFlow(siteId);

  let content: React.ReactNode = null;

  switch (step) {
    case 'keypad':
      content = (
        <StatusKeypadCard
          digits={digits}
          errorMessage={errorMessage}
          onDigit={enterDigit}
          onClear={clearDigits}
          onArm={submitArm}
          onDisarm={submitDisarm}
        />
      );
      break;
    case 'acquiring-location':
      content = (
        <LoadingCard
          message={locale.virtualTablet.acquiringLocationMessage}
          data-testid="acquiring-location"
        />
      );
      break;
    case 'verifying':
      content = (
        <LoadingCard message={locale.virtualTablet.verifyingMessage} data-testid="verifying" />
      );
      break;
    case 'location-unavailable':
      content = (
        <LocationConfirmation
          failureReason={locationFailureReason}
          storeNumber={storeNumber}
          onStoreNumberChange={setStoreNumber}
          onSubmitStoreNumber={submitStoreNumber}
          onRetryLocation={retryLocation}
        />
      );
      break;
    case 'success':
      content = (
        <SuccessStatus
          action={completedAction === 'arm' ? 'arm' : 'disarm'}
          armingSecondsRemaining={armingSecondsRemaining}
          armingTotalSeconds={armingTotalSeconds}
        />
      );
      break;
  }

  return (
    // h-dvh (hard cap) + overflow-hidden: this page must never scroll.
    <div className="tw flex h-dvh w-full flex-col items-center justify-center overflow-hidden bg-background-muted p-4 sm:p-6">
      <div className="flex min-h-0 w-full flex-1 flex-col items-center justify-center">
        {content}
      </div>
    </div>
  );
};

const ComposedVirtualTablet = () => (
  <PublicWrapper>
    <VirtualTablet />
  </PublicWrapper>
);

export default ComposedVirtualTablet;
